<div class="top-performers-wrapper">
    <div class="d-flex justify-content-between" [ngClass]="{'marginb-125' : isLoading}">
        <div class="col-6 title pl-0 mb-3 mt-1">
            <span class="title-text mr-1" cvLocalizedText langSection="Games_History" langKey="Top_Performers">Top Performers</span>
        </div>
    
        <ng-container *ngIf="(game?.GameType == gameTypeEnum.Connect3 || game?.GameType == gameTypeEnum.Blackout) && !isLoading">
            <select class="form-control select-rounds col-5"
                    [disabled]="isLoading"
                    [(ngModel)]="gameMetric"
                    (ngModelChange)="onChangeMetric()">
                <option *ngFor="let option of metricList" [ngValue]="option">{{ option.MetricDetail.Abbrev }}</option>
            </select>
        </ng-container>
    </div>
    
    <div *ngIf="isLoading" class="cv-loader-wrapper">
        <div class="cv-loader-container">
          <cv-loader [loaderType]="'auto'" [size]="'medium'" [overlay]="false" [isFullScreen]="false"></cv-loader>
        </div>
    </div>
    
    <ng-container *ngIf="!isLoading">
        <ng-container *ngIf="topPerformers?.length > 0; else emptyCard">
            <div class="d-flex justify-content-between mb-2" *ngFor="let player of topPerformers; let i = index">
                <div class="d-flex col-8 pl-0">
                    <div class="topDogRankIcon topDogRank{{i+1}}"></div>
                    <span class="player-name align-self-center mx-2">{{ player.LoginName }}</span>
                </div>
                <div class="col-4 pr-0 text-right">
                    <span>{{ player.MetricDisplayValue }}</span>
                </div>
            </div>
        </ng-container>
    
        <ng-template #emptyCard>
            <div class="empty-section text-center align-self-center mt-5" cvLocalizedText langSection="Games_History" langKey="Empty_Top_Performers">No qualified participants.</div>
        </ng-template>
    </ng-container>    
</div>
